import Vue from "vue";
import Vuex from "vuex";
import sideBarStore from "./state/modules/sideBarStore.js"
import userModule from "./state/modules/userModule.js"

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    sideBarStore,
    userModule
  }
});
